/**
 * Shared client-side UI state.
 *
 * Deliberately small. Server data belongs in TanStack Query and screen-local
 * state belongs in useState; this holds only what several unrelated components
 * need to agree on.
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UiState {
  /** The site filter in the top bar. Null means "everything in my scope". */
  activeSiteId: string | null;
  setActiveSite: (siteId: string | null) => void;
}

export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      activeSiteId: null,
      setActiveSite: (activeSiteId) => set({ activeSiteId }),
    }),
    {
      name: 'kdoshr-ui',
      partialize: (state) => ({
        activeSiteId: state.activeSiteId,
      }),
    },
  ),
);
